import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { VdJsonViewerService } from './vd-json-viewer.service';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ConfirmationService } from 'primeng/api';
import * as moment from 'moment';
import {
  getDataSourceCountryList,
  SetDataSourceCountryList
} from 'visa-store';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-vd-json-viewer',
  templateUrl: './vd-json-viewer.component.html',
  styleUrls: ['./vd-json-viewer.component.scss']
})
export class VdJsonViewerComponent implements OnInit {
  visaId: number;
  pdfJSON: any[];
  editMode = false;
  editablePdfJson: any[];
  pdfIndex: number;
  isSelectAllMainTable = false;
  elementTypeArr: any[];
  enableGroupBtn = false;
  createdGroupsArr: any[] = [];
  groupListShow = false;
  replaceShow = false;
  editElementShow = false;
  editObj: any;
  elementList: any[];
  fromYear: string;
  toYear: string;
  editablePDFJsonDetails: any;
  newOption: string;
  searchString: string;
  filterededitablePdfJson: any[];
  filteredList: any[];
  replaceString: string;
  isSelectAllSearchTable = false;
  enableReplaceBtn = false;
  editSearchElementShow = false;
  replaceSearchClicked = false;
  showGroupCheckBox = false;
  showGroupCountryState = false;
  showGroupCountryStatePopup = false;
  countryStateList: any[];
  countryList: any[];
  isView: boolean = false;
  isEditVisa:boolean = false;
  constructor(
    private vdJsonViewerService: VdJsonViewerService,
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private confirmationService: ConfirmationService,
    private referenceLibraryService: ReferenceLibraryService
  ) {
    this.toYear = moment().add(5, 'years').format('YYYY');
    this.fromYear = moment().subtract(5, 'years').format('YYYY');
    this.elementTypeArr = [{
      name: 'Define as...',
      value: null
    }, {
      name: 'Part Title',
      value: 'part'
    }, {
      name: 'Sub Header',
      value: 'subHeader'
    }, {
      name: 'Element Header',
      value: 'elementHeader'
    }, {
      name: 'Element',
      value: 'element'
    }];
    this.elementList = [
      { name: 'Select', code: null },
      { name: 'Textbox', code: 'Textbox' },
      { name: 'Dropdown', code: 'Dropdown' },
      { name: 'Datepicker', code: 'Datepicker' },
      { name: 'Checkbox', code: 'Checkbox' },
      { name: 'Radiobutton', code: 'Radiobutton' },
      { name: 'CustomRadiobutton', code: 'CustomRadiobutton' },
      { name: 'Questionnaire', code: 'Questionnaire' },
      { name: 'Switch with Explanation', code: 'switchWithExp' },
      { name: 'Text Area', code: 'textarea' }
    ];
    this.getCountry();
  }

  ngOnInit() {
    this.store.select(fromVDTask.getVDVisaId)
      .pipe(take(1))
      .subscribe((visaId: number) => {
        this.visaId = visaId;
        if (this.visaId) {
          this.getUploadedFilesJSON();
        } else {
          this.router.navigate(
            ['../../../../manage-visa/created-visas'],
            { relativeTo: this.route }
          );
        }
      });
    this.route.params.subscribe((params) => {
      this.isView = (params['isView'] === 'view') ? true : false;
    });
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
  }

  getUploadedFilesJSON() {
    if (this.visaId) {
      this.vdJsonViewerService.getUploadedFilesJSON(this.visaId)
        .pipe(take(1))
        .subscribe((response: any) => {
          if (response) {
            this.pdfJSON = this.vdJsonViewerService.preJSONViewerEngine(response);
           // console.log("this.pdfJSON", this.pdfJSON );
            // this.pdfJSON = this.vdJsonViewerService.preJSONViewerEngine(response)
            //   .map(x => {
            //     return {
            //       ...x,
            //       elementList: x.elementList.slice(0, 9)
            //     };
            //   });
          }
        });
    }
  }

  editPDF(pdfJSON, pdfIndex) {
    this.ngxService.start();
    setTimeout(() => {
      this.enableGroupBtn = false;
      this.editMode = true;
      this.pdfIndex = pdfIndex;
      this.isSelectAllMainTable = false;
      this.showGroupCheckBox = false;
      this.showGroupCountryState = false;
      this.editablePDFJsonDetails = {
        id: pdfJSON.id,
        taskTypeId: pdfJSON.taskTypeId
      };
      this.createdGroupsArr.splice(0, this.createdGroupsArr.length);
      this.editablePdfJson = JSON.parse(JSON.stringify((pdfJSON.elementList as any[])
        .map(x => {
          x.isSelected = false;
          x.speedDialClicked = false;
          x.groupClosed = false;
          x.isMainEdit = false;
          if (x.group && !this.createdGroupsArr.includes(x.group)) {
            this.createdGroupsArr.push(x.group);
          }
          return x;
        })));
      this.ngxService.stop();
    }, 0);
  }

  selectAllMainTable() {
    this.editablePdfJson = this.editablePdfJson.map(x => {
      if (x.deleted) {
        x.isSelected = false;
      } else {
        x.isSelected = this.isSelectAllMainTable;
      }
      return x;
    });
    this.enableGroupBtn = this.isSelectAllMainTable;
  }

  onSpeedDialClick(jsonObj: any, isOpen: boolean) {
    this.editablePdfJson = this.editablePdfJson.map(x => {
      x.speedDialClicked = false;
      return x;
    });
    jsonObj.speedDialClicked = isOpen;
  }

  onBack() {
    this.editablePDFJsonDetails = null;
    this.editablePdfJson = [];
    this.createdGroupsArr = [];
    this.editMode = false;
    this.groupListShow = false;
  }

  onOpenRefreshAndFind() {
    this.replaceShow = true;
    this.searchString = '';
    this.replaceString = '';
    this.isSelectAllSearchTable = false;
    this.filterededitablePdfJson = JSON.parse(JSON.stringify(this.editablePdfJson));
  }

  onGroupSelected() {
    const index = this.editablePdfJson.findIndex(x => x.isSelected);
    const selectedRecords = this.editablePdfJson.filter(x => x.isSelected);
    const groupValuesFromRecords = this.createdGroupsArr.map(x => Number(x.replace('Group ', '')));
    const groupValues = groupValuesFromRecords.length > 0 ? groupValuesFromRecords : [0];
    const maxGroupValue = Math.max(...groupValues);
    selectedRecords.forEach((x, i) => {
      x.group = `Group ${maxGroupValue + 1}`;
      x.groupElementsPlacement =
        i === 0 ?
          'group-first' :
          i === (selectedRecords.length - 1) ?
            'group-last' :
            'group-middle';
      x.isSelected = false;
    });
    this.editablePdfJson.splice(index, 0, {
      getFieldType: 'groupTitle',
      getFullyQualifiedName: `Group ${maxGroupValue + 1}`,
      partNumber: null,
      wholepartString: `Group ${maxGroupValue + 1}`,
      defineAs: 'group',
      isSelected: false,
      speedDialClicked: false,
      dropDownValuesList: null,
      deleted: false,
      group: `Group ${maxGroupValue + 1}`,
      groupElementsPlacement: null,
      groupClosed: false
    });
    this.createdGroupsArr.push(`Group ${maxGroupValue + 1}`);
    this.enableGroupBtn = false;
  }

  onUnGroupSelected(groupName: string) {
    this.groupListShow = false;
    const index = this.editablePdfJson.findIndex(x => x.group === groupName && x.getFieldType === 'groupTitle');
    this.editablePdfJson.splice(index, 1);
    this.editablePdfJson.filter(x => x.group === groupName).forEach(x => {
      x.group = null;
      x.groupElementsPlacement = null;
      x.groupClosed = false;
    });
    this.createdGroupsArr.splice(this.createdGroupsArr.indexOf(groupName), 1);
  }

  onDeleteSelected(type?) {
    const arrToEdit = type === 'searchTable' ? this.filteredList : this.editablePdfJson;
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        arrToEdit
          .filter(x => x.isSelected)
          .forEach(x => {
            x.isSelected = false;
            x.deleted = true;
          });
      }
    });
  }

  onRowDelete(jsonObj: any) {
    jsonObj.speedDialClicked = false;
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        jsonObj.deleted = true;
      }
    });
  }

  lastIndexOf(array, key, value) {
    for (let i = array.length - 1; i >= 0; i--) {
      if (array[i][key] === value)
        return i;
    }
    return -1;
  }

  onGroupCheckbox() {
    const lastIndex = this.lastIndexOf(this.editablePdfJson, 'isSelected', true);
    if (lastIndex !== -1) {
      const selectedRecords = this.editablePdfJson.filter(x => x.isSelected);
      const properties = selectedRecords.map(y => {
        if (y.getFieldType === "Checkbox" && y.properties?.length === 1 && y.getFullyQualifiedName !== y.properties[0].data_field_name) {
          return {
            ...y.properties[0]
          }
        }
        return {
          name: y.wholepartString,
          isChecked: false,
          data_field_name: y.getFullyQualifiedName
        }
      });
      const uuid = this.vdJsonViewerService.uuid();
      const newCheckboxObj = {
        ...selectedRecords[0],
        getFullyQualifiedName: uuid,
        elementId: uuid,
        data_field_name: uuid,
        isSelected: false,
        properties
      };
      this.editablePdfJson.splice(lastIndex + 1, 0, newCheckboxObj);
      selectedRecords.forEach(x => {
        x.isSelected = false;
      });
      this.showGroupCheckBox = false;
    }
  }

  select() {
    this.editablePdfJson.forEach((x, i) => {
      x.index = i;
    });
    const selectedRecords = this.editablePdfJson.filter(x => x.isSelected);
    let isSequence = true;
    if (selectedRecords && selectedRecords.length > 1) {
      let diff: number;
      for (let index = 0; index < selectedRecords.length; index++) {
        if (selectedRecords[index].group) {
          isSequence = false;
          break;
        } else {
          if (index === 0) {
            diff = selectedRecords[index].index - index;
          } else if (selectedRecords[index].index - index === diff) {
            continue;
          } else {
            isSequence = false;
            break;
          }
        }
      }
      this.enableGroupBtn = isSequence;
      if (!selectedRecords.find(x => x.getFieldType && x.getFieldType !== 'Checkbox')) {
        this.showGroupCheckBox = true;
      } else {
        this.showGroupCheckBox = false;
      }
      if (selectedRecords.filter(x => !['groupTitle'].includes(x.getFieldType)).length === 2) {
        this.showGroupCountryState = true;
      } else {
        this.showGroupCountryState = false;
      }
    } else {
      this.enableGroupBtn = false;
      this.showGroupCheckBox = false;
      this.showGroupCountryState = false;
    }
  }

  toggleGroup(groupName: string, groupClosed: boolean): void {
    this.editablePdfJson
      .filter(x => x.group === groupName)
      .forEach(x => {
        x.groupClosed = groupClosed;
      });
  }

  onRowDuplicate(jsonObj: any, index: number) {
    jsonObj.speedDialClicked = false;
    this.editablePdfJson.splice(index, 0, {
      ...jsonObj,
      getFullyQualifiedName: this.vdJsonViewerService.uuid()
    });
  }

  onRowEdit(jsonObj: any, index: number, isSearchTable?: boolean) {
    jsonObj.speedDialClicked = false;
    let properties: any[] = null;
    if (jsonObj.properties && jsonObj.properties.length > 0) {
      properties = jsonObj.properties.map(x => {
        if (typeof x === 'string') {
          return {
            name: x,
            isEdit: false
          };
        } else if (typeof x === 'object') {
          return {
            ...x,
            isEdit: false
          };
        }
      });
    }
    this.editObj = {
      ...jsonObj,
      preEdit: {
        ...jsonObj,
        index
      },
      index,
      properties
    };
    this.editElementShow = true;
  }

  onRowEditClose() {
    const { index, ...jsonObj } = this.editObj.preEdit;
    this.editablePdfJson.splice(this.editObj.index, 1, {
      ...jsonObj
    });
    this.editElementShow = false;
  }

  onRowEditSave() {
    const { preEdit, index, ...jsonObj } = this.editObj;
    this.editablePdfJson.splice(this.editObj.index, 1, {
      ...jsonObj,
      properties: jsonObj.getFieldType === 'Dropdown' ? jsonObj.properties.map(x => {
        return x.name;
      }) : jsonObj.properties,
      dropDownValuesList: jsonObj.getFieldType === 'Dropdown' ? jsonObj.properties.map(x => {
        return x.name;
      }) : null
    });
    this.editElementShow = false;
  }

  onFieldTypeChange() {
    this.editObj = this.vdJsonViewerService.setFieldType(this.editObj);
    if (this.editObj.properties && this.editObj.properties.length > 0) {
      if (this.editObj.properties && this.editObj.properties.length > 0) {
        this.editObj.properties = this.editObj.properties.map(x => {
          if (typeof x === 'string') {
            return {
              name: x,
              isEdit: false
            };
          } else if (typeof x === 'object') {
            return {
              ...x,
              isEdit: false
            };
          }
        });
      }
    }
  }

  onOptionItemEditClose(item: any) {
    item.name = item.preEditValue.trim();
    item.isEdit = false;
  }

  onOptionItemEdit(item: any) {
    item.preEditValue = item.name.trim();
    item.isEdit = true;
  }

  onOptionItemDelete(index: number) {
    this.editObj.properties.splice(index, 1);
  }

  addOptionItem() {
    this.editObj.properties.push({
      name: this.newOption,
      isChecked: false,
      isEdit: false
    });
    this.newOption = null;
  }

  onDefinitionChange(e, jsonObj: any, index: number) {
    switch (jsonObj.defineAs) {
      case 'part':
        jsonObj.getFieldType = 'partTitle';
        this.editablePdfJson.splice(index, 1, ...this.vdJsonViewerService.setFieldType(jsonObj));
        break;
      case 'subHeader':
        jsonObj.getFieldType = 'subHeadingTitle';
        this.editablePdfJson.splice(index, 1, ...this.vdJsonViewerService.setFieldType(jsonObj));
        break;
      case 'elementHeader':
        jsonObj.getFieldType = 'elementHeading';
        this.editablePdfJson.splice(index, 1, ...this.vdJsonViewerService.setFieldType(jsonObj));
        break;
      case 'element':
        this.editObj = {
          ...jsonObj,
          preEdit: {
            ...jsonObj,
            index,
            defineAs: jsonObj.getFieldType === 'partTitle' ? 'part' :
              jsonObj.getFieldType === 'subHeadingTitle' ? 'subHeader' :
                jsonObj.getFieldType === 'elementHeading' ? 'elementHeader' : null
          },
          index
        };
        this.editElementShow = true;
        break;
    }
  }

  onJSONEditSave() {
    const payload = this.editablePdfJson.filter(x => !x.deleted).map(x => {
      if (x.stateList) {
        x.stateList = [];
      }
      return this.vdJsonViewerService.setFieldType(x);
    });
    this.vdJsonViewerService.saveEditedJSON({
      ...this.editablePDFJsonDetails,
      jsonViewerFile: JSON.stringify([{
        isJSONConverted: true
      }, ...payload])
    })
      .pipe(take(1))
      .subscribe((response: boolean) => {
        if (response) {
          this.pdfJSON[this.pdfIndex].elementList = JSON.parse(JSON.stringify(this.editablePdfJson));
        }
      });
  }

  onSearch() {
    if (this.searchString && this.searchString !== '') {
      this.replaceSearchClicked = true;
      this.filteredList = this.filterededitablePdfJson
        .map(x => {
          x.highlightString = null;
          return x;
        })
        .filter((el) => el.wholepartString.includes(this.searchString))
        .map(x => {
          x.highlightString = String(x.wholepartString).split(this.searchString).join(`<span class="highlight-search-text-json-viewer">${this.searchString}</span>`);
          return x;
        });
    }
  }
  onReplace() {
    const replaceString = this.replaceString ? this.replaceString : '';
    const searchRegExp = new RegExp(this.searchString, 'gi');
    this.filteredList.filter(x => x.isSelected).forEach(x => {
      x.wholepartString = x.wholepartString.replace(searchRegExp, replaceString);
      x.highlightString = null;
      x.isSelected = false;
    });
  }
  selectAllSearchTable() {
    this.filterededitablePdfJson = this.filterededitablePdfJson.map(x => {
      if (x.deleted) {
        x.isSelected = false;
      } else {
        x.isSelected = this.isSelectAllSearchTable;
      }
      return x;
    });
    this.enableReplaceBtn = this.isSelectAllSearchTable;
  }
  closeSearchPopup() {
    this.replaceShow = false;
    this.isSelectAllSearchTable = false;
    this.filterededitablePdfJson = [];
    this.filteredList = [];
    this.replaceSearchClicked = false;
  }
  selectedSearchResult() {
    this.enableReplaceBtn = this.filterededitablePdfJson.some(x => x.isSelected);
  }

  onReplaceSave() {
    this.editablePdfJson = JSON.parse(JSON.stringify(this.filterededitablePdfJson));
    this.editSearchElementShow = false;
  }

  onRowSearchEdit(jsonObj: any) {
    jsonObj.editableWholePartString = jsonObj.wholepartString;
    jsonObj.editSearchElementShow = true;
  }

  searchPopupElementEditSave(jsonObj: any) {
    if (jsonObj.editableWholePartString &&
      jsonObj.editableWholePartString.trim().length > 0) {
      jsonObj.wholepartString = jsonObj.editableWholePartString;
      jsonObj.editSearchElementShow = false;
      this.onSearch();
    }
  }

  onRowSearchEditClose() {
    this.editSearchElementShow = false;
  }

  onRowEditSearchSave(editObj: any) {
    this.filterededitablePdfJson = this.filterededitablePdfJson.map(x => {
      x.wholepartString = (x.elementId === editObj.elementId) ? editObj.wholepartString : x.wholepartString;
      return x;
    })
  }

  onRowEditSearchClose() {
    this.editSearchElementShow = false;
  }

  makeEditable(jsonObj: any) {
    jsonObj.mainEditableWholePartString = jsonObj.wholepartString;
    jsonObj.isMainEdit = true;
  }

  mainElementEditSave(jsonObj: any) {
    if (jsonObj.mainEditableWholePartString &&
      jsonObj.mainEditableWholePartString.trim().length > 0) {
      jsonObj.wholepartString = jsonObj.mainEditableWholePartString;
      jsonObj.isMainEdit = false;
    }
  }

  nextStep() {
    if (this.isView) {
      this.router.navigate([`../../build-steps/view`], { relativeTo: this.route });
    } else {
      this.router.navigate([`../build-steps`], { relativeTo: this.route });
    }

  }

  previousStep() {
    if (this.isView) {
      this.router.navigate([`../../upload-pdf/view`], { relativeTo: this.route });
    } else {
      this.router.navigate([`../upload-pdf`], { relativeTo: this.route });
    }

  }

  onReOrderItemEditOption(direction: string, itemIndex: number) {
    let firstIndex: number;
    let secondIndex: number;
    if (direction === 'up') {
      firstIndex = itemIndex - 1;
      secondIndex = itemIndex;
    } else {
      firstIndex = itemIndex;
      secondIndex = itemIndex + 1;
    }
    const firstObj = JSON.parse(JSON.stringify(this.editObj.properties[firstIndex]));
    const secondObj = JSON.parse(JSON.stringify(this.editObj.properties[secondIndex]));
    this.editObj.properties[firstIndex] = secondObj;
    this.editObj.properties[secondIndex] = firstObj;
  }

  onGroupCountryState() {
    this.showGroupCountryStatePopup = true;
    this.countryStateList = this.editablePdfJson
      .filter(x => x.isSelected)
      .map((x, i) => {
        return {
          ...x,
          isCountry: i === 0
        };
      });
  }

  onCountryStateSelection() {
    this.countryStateList[1].isCountry = !this.countryStateList[0].isCountry;
  }

  onCreateCountryState() {
    setTimeout(() => {
      const countryStateObj = {
        getFieldType: 'countryState',
        stateList: [],
        defaultProperties: {
          inputArray: [
            {
              name: 'country',
              data_field_name: this.countryStateList.find(x => x.isCountry).data_field_name
            },
            {
              name: 'state',
              data_field_name: this.countryStateList.find(x => !x.isCountry).data_field_name
            }
          ]
        }
      };
      const maxIndex = Math.max(...this.countryStateList.map(x => x.index));
      this.editablePdfJson.splice(maxIndex + 1, 0, this.vdJsonViewerService.setFieldType(countryStateObj));
      this.showGroupCountryStatePopup = false;
    }, 0);
  }

  onCloseCountryState() {
    this.showGroupCountryStatePopup = false;
  }

  getCountry() {
    this.store.pipe(select(getDataSourceCountryList))
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data && data.length > 0) {
          data.unshift({
            name: 'Select',
            code: null
          });
          this.countryList = data;
        } else {
          this.referenceLibraryService.getDataSource('COUNTRY', '')
            .pipe(take(1))
            .subscribe((response: any[]) => {
              if (response) {
                this.countryList = JSON.parse(JSON.stringify(response));
                this.countryList.unshift({
                  name: 'Select',
                  code: null
                });
              } else {
                this.countryList = [];
              }
              this.store.dispatch(new SetDataSourceCountryList(response || null));
            });
        }
      });
  }

  handleCountryChange(evt, element) {
    let countryCode = evt.value;
    this.referenceLibraryService.getStatesFromStore(countryCode)
      .pipe(take(1))
      .subscribe((states: any[]) => {
        if (states) {
          states.unshift({
            stateProvinceName: 'Select',
            stateProvinceCode: null
          });
          element.stateList = states;
        } else {
          this.referenceLibraryService.getStatesFromApi(countryCode)
            .pipe(take(1))
            .subscribe((data: any[]) => {
              if (data) {
                data.unshift({
                  stateProvinceName: 'Select',
                  stateProvinceCode: null
                });
                element.stateList = data;
              } else {
                element.stateList = [];
              }
            });
        }
      });
  }

}
